var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$attrs.center)?_c('MglMap',_vm._b({staticClass:"mgl-map"},'MglMap',{ ..._vm.$attrs, ..._vm.defaults },false),[_vm._t("default"),(_vm.$attrs.center)?_c('MglMarker',{attrs:{"coordinates":_vm.$attrs.center}}):_vm._e(),_c('MglNavigationControl',{attrs:{"position":"top-right"}})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }